// src/components/Legal/Terms.js
import React from 'react';
import styles from './Legal.module.css';

const Terms = () => {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <h1>Terms and Conditions</h1>
        <p className={styles.lastUpdated}>Last Updated: February 22, 2024</p>

        <section className={styles.section}>
          <h2>1. Acceptance of Terms</h2>
          <p>By accessing and using Teezash's website and services, you accept and agree to be bound by these Terms and Conditions.</p>
        </section>

        <section className={styles.section}>
          <h2>2. Services</h2>
          <p>Teezash provides IoT and safety solutions. We reserve the right to:</p>
          <ul>
            <li>Modify or withdraw any part of our services</li>
            <li>Limit access to certain features</li>
            <li>Change our service offerings at any time</li>
          </ul>
        </section>

        <section className={styles.section}>
          <h2>3. Intellectual Property</h2>
          <p>All content on this website, including but not limited to text, graphics, logos, and software, is the property of Teezash and is protected by intellectual property laws.</p>
        </section>

        <section className={styles.section}>
          <h2>4. Limitation of Liability</h2>
          <p>Teezash shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use of our services.</p>
        </section>

        <section className={styles.section}>
          <h2>5. Contact Information</h2>
          <p>For any questions regarding these Terms, please contact us at:</p>
          <p>Email: contact@teezash.com</p>
          <p>Phone: 09337813196</p>
        </section>
      </div>
    </div>
  );
};

export default Terms;